import { Tables } from '@/lib/supabase/supabase_types_override';
import { supabase } from '@/lib/supabase/supabaseClient';

export const inviteUserToProject = async ({
  projectId,
  invitedUserEmail,
}: {
  projectId: Tables<'project'>['id'];
  invitedUserEmail: Tables<'user'>['email'];
}) => {
  return await supabase.functions.invoke(`rest/project/${projectId}/invite`, {
    body: JSON.stringify({ invitedUserEmail }),
    method: 'POST',
    headers: {
      dev: 'true',
      origin: location.origin,
    },
  });
};
